module.exports = "<p>\r\n  not-found works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/not-found/not-found.component.html
// module id = ../../../../../src/app/not-found/not-found.component.html
// module chunks = main